import axios from "axios";
const API_URL = process.env.REACT_APP_API;

export async function obtenerTicketsPorEventoService(eventoId: number) {
  try {
    const response = await axios.get(`${API_URL}tickets/por-evento/${eventoId}`);
    const data = response.data?.doc?.data || [];
    return data;
  } catch (error) {
    console.error("Error en obtenerTicketsPorEventoService:", error);
    throw error;
  }
}

export async function verificarTicketsExistenService(): Promise<boolean> {
  try {
    const response = await axios.get(`${API_URL}tickets/existen`);
    return response.data?.doc?.data?.existen ?? false;
  } catch (error) {
    console.error("Error en verificarTicketsExistenService:", error);
    return false;
  }
}

export async function insertarFisicosService(
  folioDesde: string,
  folioHasta: string,
  eventoId: number | null
): Promise<{ insertados: number; yaExistian: string[] }> {
  const response = await axios.post(`${API_URL}tickets/insertar-fisicos`, {
    folioDesde,
    folioHasta,
    eventoId,
  });
  return response.data?.doc?.data;
}

export async function getWalletTicketByFolioService(
  folio: string
): Promise<{ folio: string; saldo: number; nombre: string | null }> {
  const response = await axios.get(`${API_URL}tickets/wallet-folio/${folio}`);
  return response.data?.doc?.data;
}

export async function traspasarWalletAFisicoService(
  folioWallet: string,
  folioFisico: string,
  monto: number
): Promise<{ folioWallet: string; folioFisico: string; monto: number; nuevoSaldoWallet: number }> {
  const response = await axios.post(`${API_URL}tickets/traspasar`, {
    folioWallet,
    folioFisico,
    monto,
  });
  return response.data?.doc?.data;
}
